<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div style="padding-bottom: 5px;display: flex;width:100%;align-content: stretch;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
          <div style="display: flex; justify-content: center; align-items: center;">
            {{ $t('CargoMsg.Cargo_TaskScenario') + ':' + ColumnUtils.showTypeLabelFunc(form.taskScenario, SystemConstants.TASK_SCENARIO_LIST) }}
          </div>
          <div>
            <el-button type="success" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
            <el-button type="primary" @click="cancelHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
          </div>
        </div>
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%" :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}" @tab-click="handleClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_ScenarioSettings')" name="scenarioSettings">
              <scenario-settings ref="scenarioSettings" @refreshDone="refreshDoneHandler" @taskChange="taskChangeHandler" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_RuleSettings')" name="ruleSettings">
              <rule-settings v-if="form.taskScenario === SystemConstants.TASK_SCENARIO_1.code" ref="ruleSettings" @ruleSettingChange="ruleSettingChangeHandler" />
              <settlement-rate-settings v-if="form.taskScenario === SystemConstants.TASK_SCENARIO_2.code" ref="ruleSettings" @ruleSettingChange="ruleSettingChangeHandler" />
              <mls-send-setting
                v-if="form.taskScenario === SystemConstants.TASK_SCENARIO_3.code || form.taskScenario === SystemConstants.TASK_SCENARIO_4.code || form.taskScenario === SystemConstants.TASK_SCENARIO_5.code"
                ref="ruleSettings"
                :task-scenario="form.taskScenario"
                @ruleSettingChange="ruleSettingChangeHandler"
              />
              <third-party-send-settings v-if="form.taskScenario === SystemConstants.TASK_SCENARIO_6.code" ref="ruleSettings" :task-scenario="form.taskScenario" @ruleSettingChange="ruleSettingChangeHandler" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_CommandSettings')" name="commandSettings">
              <command-settings ref="commandSettings" @refreshDone="refreshDoneHandler" @ruleTaskChange="ruleTaskChangeHandler" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scenarioSettings from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/scenarioSettings'
import RuleSettings from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/ruleSettings.vue'
import CommandSettings from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/commandSettings.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { AutomationConfig } from '@/class/model/sys/AutomationConfig'
import { saveConfigFunc } from '@/api/sysAutoConfig/sysAutoConfig'
import { ScenarioSettings } from '@/class/model/sys/ScenarioSettings'
import $store from '@/store'
import SettlementRateSettings
  from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/settlementRateSettings.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import MlsSendSetting from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/mlsSendSettings.vue'
import ThirdPartySendSettings from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/thirdPartySendSettings.vue'

export default {
  name: 'AutoConfigDetail',
  components: { ThirdPartySendSettings, MlsSendSetting, SettlementRateSettings, CommandSettings, RuleSettings, scenarioSettings },
  props: {},
  data() {
    return {
      activeTabName: 'scenarioSettings',
      action: '',
      form: new AutomationConfig().fillDefaultValue().getData(),
      task: new ScenarioSettings().fillDefaultValue().getData(),
      needRefreshMap: new Map()
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    }, ColumnUtils() {
      return ColumnUtils
    }
  },
  methods: {
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理（在编辑状态下）
    async endTabHandler(tabName) {
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    handleClick(tab, event) {
      this.activeTabName = tab.name
      this.$nextTick(async() => {
        if (this.activeTabName === 'ruleSettings') {
          await this.$refs.ruleSettings.onShow(this.action, this.form, this.task)
        } else {
          await this.$refs[this.activeTabName].onShow(this.action, this.form, this.needRefreshMap[this.activeTabName])
        }
      })
    },
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, form) {
      this.activeTabName = 'scenarioSettings'
      this.needRefreshMap = new Map()
      this.action = action
      this.form = form
      if (this.$refs['commandSettings']) {
        this.$refs['commandSettings'].clearData()
      }
      this.$nextTick(async() => {
        await this.$refs[this.activeTabName].onShow(this.action, this.form, this.needRefreshMap[this.activeTabName])
      })
    },
    refreshDoneHandler(name) {
      this.needRefreshMap[name] = false
    },
    taskChangeHandler(data) {
      if (data) {
        this.task = data
      }
    },
    // 配置发生变动
    async ruleSettingChangeHandler(data) {
      await this.$refs.scenarioSettings.refreshProperties(data)
    },
    // 指令发生变动
    async ruleTaskChangeHandler(data) {
      await this.$refs.scenarioSettings.refreshTask(data)
    },
    async saveHandler() {
      const loading = getLoading4Cxt(this)
      const params = { ... this.form }
      if (this.$refs['ruleSettings'] && this.activeTabName === 'ruleSettings') {
        await this.$refs['ruleSettings'].toNext()
      }
      if (this.$refs['scenarioSettings']) {
        const settings = await this.$refs['scenarioSettings'].getSubmitData()
        if (settings) {
          params.deleteUuids = settings.deleteUuids
          params.taskDetails = settings.taskDetails
          for (const td of params.taskDetails) {
            if (td.propertiesData) {
              if (!td.propertiesData.autoInputBy && this.form.taskScenario === SystemConstants.TASK_SCENARIO_1.code) {
                this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_InvoicedBy'))
                loading.close()
                return
              }
              td.propertiesData.allCharges = []
              td.propertiesData.allEntities = []
              td.propertiesData.entities = []
              td.propertiesData.invoice = {}
              td.propertiesData.chargeMap = {}
              td.propertiesData.invoices = []
              delete td.propertiesData.invoiceGoodsNameList
            }
          }
        }
      }
      if (this.$refs['commandSettings']) {
        const commands = await this.$refs['commandSettings'].getSubmitData()
        if (commands) {
          params.deleteCommandUuids = commands.deleteCommandUuids
          params.commandDetails = commands.commandDetails
        }
      }
      if (!this.checkData(params)) {
        loading.close()
        return
      }
      params.branchId = $store.getters.currentOfficeId
      saveConfigFunc(params).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.$emit('refresh')
      }).finally(() => {
        loading.close()
      })
    },
    checkData(params) {
      const details = params.commandDetails
      if (!Array.isArray(details) || details.length === 0) {
        // 如果允许空数组，直接返回 true；否则提示错误
        return true
      }

      const seen = new Set()
      for (const item of details) {
        const name = item?.name?.trim()
        if (!name) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_CommandName'))
          return false
        }
        const commandName = item.commandName
        if (seen.has(commandName)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Command') + this.$t('CargoMsg.Cargo_CanNotRepeat'))
          return false
        }
        seen.add(commandName)
      }
      return true
    },
    cancelHandler() {
      this.$emit('refresh')
    }
  }
}
</script>
